import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_DISHES, {
      queryParams: {
        group: 'ultraxeno',
        limit: 2000,
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch dishes',
        data: null,
      }
    }

    // Support both DishesController ([...]) and RestaurantsController ({dishes: [...]})
    const dishesData = Array.isArray(raw.data) ? raw.data : (raw.data?.dishes || [])
    const rawTotal = raw.total || raw.data?.total || dishesData.length

    // 1. Mapping des données pour l'interface
    let data = dishesData.map(el => {
      const storeName = typeof el.restaurant?.name === 'string' 
        ? el.restaurant.name 
        : (el.restaurant?.name?.name || '')

      const categoryName = typeof el.category === 'string' 
        ? el.category 
        : (el.category?.name || '')

      return {
        id: String(el.id || el._id || ''),
        title: String(el.name || el.title || ''),
        price: el.price || 0,
        storeId: String(el.restaurant?.id || el.restaurantId || el.storeId || ''),
        storeName: storeName,
        currency: el.currency || 'XOF',
        description: String(el.description || ''),
        category: categoryName,
        categoryId: String(el.categoryId || ''),
        principalImageUrl: el.principalImageUrl || (el.images && el.images[0]) || el.image || '',
        additionalImageUrl: el.images || [],
        options: el.options || [],
        metadata: el.metadata || {},
        cookDurationInMin: el.cookDurationInMin || 0,
        accompaniements: el.accompaniments || el.accompaniements || [],
        isPublished: el.isPublished !== undefined ? el.isPublished : (el.active !== false),
        isFeatured: el.isFeatured || false,
        active: el.active !== false
      }
    })

    // 2. Filtrage local par restaurant
    if (payload?.storeId) {
      data = data.filter(el => el.storeId === payload.storeId)
    }

    // 3. Recherche textuelle locale (sécurisée)
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()

    if (searchTerm) {
      data = data.filter(el => {
        return (
          el.id.toLowerCase().includes(searchTerm) ||
          el.title.toLowerCase().includes(searchTerm) ||
          el.description.toLowerCase().includes(searchTerm) ||
          el.storeName.toLowerCase().includes(searchTerm) ||
          el.category.toLowerCase().includes(searchTerm)
        )
      })
    }

    // 4. Tri dynamique
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') {
          return valA.localeCompare(valB) * order
        }
        if (typeof valA === 'number' && typeof valB === 'number') {
          return (valA - valB) * order
        }
        return 0
      })
    }

    // 5. Retour avec le total recalculé si filtrage/recherche appliquée
    const isFiltered = Boolean(payload?.storeId || searchTerm)

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: isFiltered ? data.length : rawTotal,
        result: paginated,
      },
    }
  },
}